/**
 * Clerk publishable key (frontend). Vite la inyecta en build — ver vite.config.ts.
 *
 * Fuente única: VITE_CLERK_PUBLISHABLE_KEY (convención Vite). NEXT_PUBLIC_* es
 * convención Next.js/Railway y ya no se usa en este app (Railway, sin Railway).
 */
export const EXPECTED_BRAND_KEY_PREFIX =
  (import.meta.env.VITE_CLERK_KEY_PREFIX as string | undefined)?.trim() || "pk_live_";

export function getClerkPublishableKey(): string | undefined {
  const viteKey = (import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined ?? "").trim();
  return viteKey.length > 0 ? viteKey : undefined;
}

/** true si parece una publishable key de Clerk (pk_test_ / pk_live_). */
export function isLikelyClerkPublishableKey(key: string): boolean {
  const k = key.trim();
  if (k.length < 16) return false;
  return k.startsWith("pk_test_") || k.startsWith("pk_live_");
}
